export default [
    {
        name: 'Excluir Movimentos',
        url: '/sgtec/admin/excluir-movimentos-em-lote',
        icon: 'fa fa-trash',
        regras: 'SGTEC-ADMIN-00'
    }
]
